<template>
  <div v-if="mgp.running" class="c-vote">
    <h2 class="c-vote__title">Kies de volgende track</h2>
    <div class="c-vote__list">
      <VoteTrack class="'c-vote__list-item'" v-for="(track, idx) in mgp.tracks" :key="track.id"
      :track="track" :trackIndex="idx" :hasWinner="mgp.hasWinner"/>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import VoteTrack from './VoteTrack';

export default {
  name: 'Vote',
  components: { VoteTrack},
  computed: mapState({
    mgp: state => state.mgp,
  })
}
</script>
